var $buoop = {
	vs:{
		i:10,
		f:-4,
		o:-4,
		s:8,
		c:-4
	},
	onshow: function() {
		var ageGate = false;
		if (jQuery('.age-gate-on').length) {
			console.log('YUP');
			ageGate = true;
			jQuery('html').removeClass('age-gate-on');
			jQuery('.age-gate').fadeOut();
		}
		jQuery('html').addClass('browser-update-on');
		jQuery('.browser-update').fadeIn();
		jQuery('.browser-update__wrap').on('click', function() {
			jQuery('.browser-update').fadeOut();
			jQuery('html').removeClass('browser-update-on');
			if (ageGate === true) {
				jQuery('html').addClass('age-gate-on');
				jQuery('.age-gate').fadeIn();
			}
		});
	},
	nomessage: true,
	api:4
}; 
function $buo_f(){
	var e = document.createElement("script");
	e.src = "//browser-update.org/update.min.js";
	document.body.appendChild(e);
};
try {
	document.addEventListener("DOMContentLoaded", $buo_f,false);
}
catch(e) {
	window.attachEvent("onload", $buo_f);
}